import { useEffect, useState } from 'react';
import { TypingText } from '../authBarStyling';

interface TypingAnimationProps {
    text: string;
    speed?: number;
}

const TypingAnimation: React.FC<TypingAnimationProps> = ({ text, speed = 100 }) => {
    const [displayText, setDisplayText] = useState('');
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        if (currentIndex < text.length) {
            const timeout = setTimeout(() => {
                setDisplayText(prev => prev + text[currentIndex]);
                setCurrentIndex(prev => prev + 1);
            }, speed);

            return () => clearTimeout(timeout);
        }
    }, [currentIndex, text, speed]);

    return <TypingText>{displayText}</TypingText>;
};

export default TypingAnimation; 